import AnimationLocales from 'components/Filters/AnimationLocales'
import Categories from 'components/Filters/Categories'
import Organizations from 'components/Filters/Organizations'
import Pathway from 'components/Filters/Pathway'
import PreventionPassport from 'components/Filters/PreventionPassport'
import TeachingMethods from 'components/Filters/TeachingMethods'
import Themes from 'components/Filters/Themes'
import Switch from 'components/UI/Switch'
import { useI18n } from 'context/I18nProvider'
import type { FilterValues, Value } from 'hooks/filters'
import type { Option, SelectValue } from 'shared/types'

interface TrainingFiltersProps {
  values: FilterValues
  setValue: (key: string | FilterValues, value?: Value | Value[]) => void
  getDependencyUrl: (dependencyKey: string, outputKey: string) => string
}

export default function TrainingFilters({ setValue, values, getDependencyUrl }: TrainingFiltersProps) {
  const { i18n } = useI18n()

  return (
    <div className="grid grid-cols-2 gap-4 items-center">
      <Categories
        name="theme.category"
        value={values?.['theme.category'] || []}
        onChange={(vals: SelectValue[]) => setValue('theme.category', vals)}
      />
      <Themes
        key={(values?.['theme.category'] as Option[])
          ?.map((filter: Option) => (typeof filter === 'object' && 'value' in filter ? filter?.value : filter))
          .join(',')}
        value={values?.theme || []}
        onChange={(vals: SelectValue[]) => setValue('theme', vals)}
        urlParams={`?${getDependencyUrl('theme.category', 'category')}`}
      />
      <TeachingMethods
        value={values?.teachingMethod || []}
        onChange={(vals: SelectValue[]) => setValue('teachingMethod', vals)}
      />
      <Organizations
        value={values?.['trainers.organization'] || []}
        onChange={(vals: SelectValue[]) => setValue('trainers.organization', vals)}
        draft={false}
        trainingOrganization
      />
      <AnimationLocales
        value={values?.languages || []}
        onChange={(vals: SelectValue[]) => setValue('languages', vals)}
      />
      <Pathway value={values?.pathway as string} onChange={val => setValue('pathway', val)} />
      <Switch
        checked={Boolean(values?.restricted === 'true')}
        onChange={(val: boolean) => setValue('restricted', val ? 'true' : null)}
        labelOn={i18n('catalog.filters.onnomination')}
        labelOnClassName="mr-auto text-gray-800"
      />
      <PreventionPassport
        value={values?.preventionPassport as string}
        onChange={val => setValue('preventionPassport', val)}
      />
      <Switch
        checked={Boolean(values?.certifying === 'true')}
        onChange={(val: boolean) => setValue('certifying', val ? 'true' : null)}
        labelOn={i18n('label.certifying')}
        labelOnClassName="mr-auto text-gray-800"
      />
      <Switch
        checked={Boolean(values?.availableSession === 'true')}
        onChange={(val: boolean) => setValue('availableSession', val ? 'true' : null)}
        labelOn={i18n('catalog.filters.with_available_session')}
        labelOnClassName="mr-auto text-gray-800"
      />
    </div>
  )
}
